import * as Yup from 'yup';
import slaFormModel from './slaFormModel';

const {
  formField: {
    slaTimes,
    level,
    firstResponseValue,
    firstResponseUnit,
    resolutionValue,
    resolutionUnit,
  },
} = slaFormModel;

export default [
  Yup.object().shape({
    [slaTimes.name]: Yup.array().of(
      Yup.object().shape({
        [level.name]: Yup.string().required('El nivel es requerido'),
        [firstResponseValue.name]: Yup.number()
          .required('El valor es requerido')
          .min(1, 'Mínimo 1'),
        [firstResponseUnit.name]: Yup.string().required('La unidad es requerida'),
        [resolutionValue.name]: Yup.number().required('El valor es requerido').min(1, 'Mínimo 1'),
        [resolutionUnit.name]: Yup.string().required('La unidad es requerida'),
      })
    ),
  }),
];
